import type { FaireAdvertiserProfileEntity } from "../../entity_types/advertiserProfile";

// P2 — median budget, median results, ~6mo tenure. Real numbers from Good Juju Body & Home
// (b_s5r5bgxjku), anonymized. NEW_ONLY: reorder segment was briefly on then stopped.
// Overview periods point at the single NEW campaign's period shards (no dup OVERVIEW shards).
export const advP2Median: FaireAdvertiserProfileEntity = {
  token: "adv_p2_median",
  type: "advertiserProfile",
  archetype: "median-budget-median-results",
  displayName: "Sage & Cedar Home",
  brandToken: "b_adv_p2_median",
  audienceType: "NEW_ONLY",
  globalStatus: "ACTIVE",
  tenureMonths: 6,
  budget: {
    totalBudgetDollars: 300,
    spendingMode: "MODERATE",
    nextRenewsAtDate: "2026-08-01",
    nextBillsAtDate: "2026-08-04",
  },
  overview: {
    numCustomersAcquired: 3,
    numReorderConversions: 0,
    numTotalConversions: 3,
    totalAdsSalesDollars: 1763,
    newCustomerAdsSalesDollars: 1763,
    totalAdsSpendDollars: 683,
    newCustomerAdsSpendDollars: 683,
    newCustomerBestEstimateFirstYearRoas: 2.58,
    combinedFirstYearRoas: 2.58,
  },
  availableCredit: {
    totalRemainingDollars: 0,
  },
  budgetRecommendations: {
    newCustomer: {
      minRecommendedBudgetDollars: 300,
      maxRecommendedBudgetDollars: 600,
      isEligibleForIncreaseRec: true,
    },
  },
  campaignTokens: ["camp_p2_median_new"],
  overviewPerformancePeriodTokens: [
    "perf_p2_median_new_202602",
    "perf_p2_median_new_202603",
    "perf_p2_median_new_202604",
    "perf_p2_median_new_202605",
    "perf_p2_median_new_202606",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
